export default "__VITE_ASSET__ea4f0f20__"